export function fixHtml(html:string) : string {
  let text = '';
  let i = 0;
  do {
    let p = html.indexOf('#', i);
    if (p < 0) {
      text += html.substring(i, html.length);
      break;
    }
    let q1 = html.indexOf(' ', p);
    q1 = q1 < 0 ? html.length : q1;
    let q2 = html.indexOf('<', p);
    q2 = q2 < 0 ? html.length : q2;
    let q = q1 < q2 ? q1 : q2;
    
    text += html.substring(i, p);
    if (q - p - 1 === 32) {
      text += `<a href="javascript:window.OpenCardByCodigo('CO', '${html.substring(p+1, q)}')">${html.substring(p, q)}</a>`
    } else if (!isNaN(parseInt(html.substring(p+1, q-1)))) {
      text += `<a href="javascript:window.OpenCardByCodigo('OP', ${html.substring(p+1, q)})">${html.substring(p, q)}</a>`
    } else {
      text += html.substring(p, q); // es otra cosa
    }

    i = q;
  } while (true);

  return text;
}

